import styled from '@emotion/styled';
import { TransitionGroup } from 'react-transition-group';

import IconInfoWarning from '@/assets/icons/icon_info_warning.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DateSelectorWrapper = styled.div(() =>
  mq({
    width: '100%',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const RaceProgramListWrapper = styled.div((props: { isShow: boolean }) =>
  mq({
    display: props.isShow ? 'block' : 'none',
    width: '100%',
  }),
);

export const CssGroup = styled(TransitionGroup)(() =>
  mq({
    width: '100%',
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(2, 1fr)',
    ],
    gridGap: '16px',
  }),
);

export const NoRaceText = styled.p(() =>
  mq({
    width: '100%',
    padding: '88px 0',
    backgroundColor: defaultTheme.background.white,
    color: defaultTheme.color.grayScale.dark,
    fontSize: defaultTheme.font.size.m,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

export const List = styled.li(() =>
  mq({
    width: ['100%', '100%', '100%', '100%', '630px'],
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.l,
  }),
);

export const RaceProgramInfoWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '52px',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
    ],
  }),
);

export const StopHeldText = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    margin: [
      '0 auto',
      '0 auto',
      `0 0 0 ${defaultTheme.spacing.l}`,
      `0 0 0 ${defaultTheme.spacing.l}`,
    ],
    padding: [
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
      '0',
      '0',
    ],
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    order: ['3', '3', '2', '2'],
  }),
);

export const InfoWarningIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    background: `url(${IconInfoWarning}) no-repeat center`,
    backgroundSize: 'cover',
    width: '16px',
    height: '16px',
    marginRight: defaultTheme.spacing.xs,
  }),
);

export const ProgramName = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    marginTop: defaultTheme.spacing.s,
    width: '100%',
    order: ['2', '2', '3', '3'],
  }),
);

export const LinkWrapper = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    display: 'grid',
    gridTemplateColumns: [
      'repeat(4, 1fr)',
      'repeat(4, 1fr)',
      'repeat(6, 1fr)',
      'repeat(6, 1fr)',
    ],
    gridAutoRows: '45px',
    gridGap: '4px',
  }),
);
